import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import PlaneConfig from "@/config/PlaneConfig";
import * as PIXI from "pixi.js";
import gsap from 'gsap';

export default class LineAnimatedBackgroundContainer extends BaseContainer {

    constructor(objects, settings) {
        super()
        this.settings = settings
        this.init(objects)
    }

    init(nameObjects) {
        this.speedMovieX = PlaneConfig.speed.x
        this.nextX = this.coordinateArea.startShow ? this.coordinateArea.startShow : this.coordinateArea.start.x

        Signals.multiplier.add(this.updateMultiplier, this)
        Signals.makeBets.add(this.onMakeBets, this)
        Signals.roundStart.add(this.start, this)
        Signals.roundEnd.add(this.onRoundEnd, this)

        const indexes = []
        for (let i = 0; i < nameObjects.length; i++) {
            indexes.push(i)
        }
        indexes.sort(( ) => {
            if (Math.random() < 0.3) {
                return 1;
            }
            return -1;
        });
        this.objects = []
        for (let i = 0; i < indexes.length; i++) {
            const sprite = new PIXI.Sprite(PIXI.Texture.from(nameObjects[indexes[i]]))
            const o = new PIXI.Container()
            o.addChild(sprite)
            o.name = nameObjects[indexes[i]]
            if (this.settings.mask){
                const mask = new PIXI.Sprite(PIXI.Texture.from(this.settings.mask[indexes[i]]))
                mask.y = -o.height * 3/6
                o.mask = mask;
                o.addChild(mask);
            }
            o.scale.set(this.settings.sc)
            const startY = this.startY(o)
            o.position.set(this.nextX, startY)
            this.nextX += o.width + this.delta
            this.addChild(o)
            this.objects.push(o)
            o.visible = true
            o.filters = this.filters
        }

        this.easingMultiplier = 1
    }

    update() {
        if(this.isHorisontal) {
            const deltaSpeed = (this.speedMovieX + this.speed) * this.easingMultiplier
            this.nextX -= deltaSpeed
            for (let i = 0; i < this.objects.length; i++) {
                const current = this.objects[i]
                current.x -= deltaSpeed
                if( current.x  < this.coordinateArea.delete.x - current.width) {
                    this.next(current)
                }
            }
        }
    }

    updateMultiplier(multiplier) {
        this.currentFar = multiplier
        this.isHorisontal = this.currentFar >= PlaneConfig.farStartMove
    }

    next(current) {
      //  current = this.objects[Utils.getRandomInt(0, this.objects.length - 1)]
        const startY = this.startY(current)
        if (this.nextX < this.coordinateArea.finish.x){
            this.nextX = this.coordinateArea.finish.x + current.width + this.delta + Math.round(500 * Math.random())
        }
        current.position.set(this.nextX, startY)
        this.nextX += current.width + + this.delta + Math.round(500 * Math.random())
        current.filters = this.filters
    }

    onMakeBets() {
        this.clear()
        gsap.killTweensOf(this)
        this.easingMultiplier = 1
        Signals.tick.remove(this.update, this)
        if(!this.current) {
         //  this.next()
        }
    }

    clear(){
        this.nextX = this.coordinateArea.startShow ? this.coordinateArea.startShow : this.coordinateArea.start.x
        this.objects.sort(( ) => {
            if (Math.random() < 0.3) {
                return 1;
            }
            return -1;
        });
        for (let i = 0; i < this.objects.length; i++) {
            const current = this.objects[i]
            const startY = this.startY(current)
            current.position.set(this.nextX, startY)
            this.nextX += current.width + this.delta + Math.round(500 * Math.random())

//            console.log('next  ',this.nextX, current.name)
        }
    }

    onRoundEnd() {
        Signals.tick.remove(this.update, this)
        gsap.killTweensOf(this)
        this.easingMultiplier = 1
    }

    start() {
        if(!this.current) {
           // this.next()
        }
        Signals.tick.add(this.update, this)

        this.easingMultiplier = 0
        gsap.to(this, 6, {easingMultiplier: 1})
    }

    set settings(value) {
        this._settings = value
        this.isHorisontal = false
        this.speed = value.speed
        this.delta = value.delta
        this.coordinateArea = value.coordinateArea
        this.coordinateArea.delete = value.coordinateArea.delete ? value.coordinateArea.delete : value.coordinateArea.start
        this.filters = value.filters ? value.filters : []
        this._settings.mask = value.mask
    }

    get settings() {
        return this._settings
    }

    startPosition(object){

        let startX = this.coordinateArea.start.x + Math.round(Math.random() * (this.coordinateArea.finish.x - this.coordinateArea.start.x)) - Math.round(object.width / 2)
        let startY = this.coordinateArea.start.y + Math.round(Math.random() * (this.coordinateArea.finish.y - this.coordinateArea.start.y)) - Math.round(object.height / 2)
        object.position.set(startX, startY)
    }

    startY(current){
      return this.coordinateArea.start.y + Math.round(Math.random() * (this.coordinateArea.finish.y - this.coordinateArea.start.y)) - current.height
    }
}
